import React, { useState, useEffect } from 'react';
import styles from './CheckBox.module.scss';

const CheckBox = ({ onChange, checkBoxRef, color, text }) => {
  const [active, setActive] = useState(false);

  const handleClick = () => {
    onChange(!active);
    setActive((current) => !current);
  };

  useEffect(() => {
    if (active) {
      checkBoxRef.current.style.color = '#666666';
    }
  }, [active]);

  return (
    <div
      className={`${styles.CheckBox} ${color && styles[`CheckBox__${color}`]}`}
    >
      <div
        className={`${styles.CheckBox__input} ${
          active && styles.CheckBox__inputActive
        }`}
        onClick={handleClick}
      ></div>
      <p onClick={handleClick} ref={checkBoxRef}>
        {text}
      </p>
    </div>
  );
};

export default CheckBox;
